import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterVintageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_vintage"}/>
}
